import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';
import AdvancedSearchUtility from '../../../../../../utility/AdvancedSearchUtility';

function FilterModalPatternF({
  facetType,
  facetClass,
  facets,
  setFacets,
  addFacet,
  removeFacet,
  clearFacets,
}) {
  const valueSelectOptions = facetClass.getValueSelectOptions();
  const [selectedOperator, setSelectedOperator] = useState(facetType.validOperators[0]);
  const [isAny, setIsAny] = useState(!facets.some((facet) => facet.value1 !== ''));

  const handleSelectOperatorOnChange = (e) => {
    const { value } = e.target;
    setSelectedOperator(value);
    if (facets.length > 0) {
      const updatedOperatorTypeFacets = facets
        .map((facet) => ({ ...facet, operatorId: Number(value) }));
      setFacets(updatedOperatorTypeFacets);
    }
  };

  const handleAddFacetValue = (newValue) => {
    let newFacet;
    if (!isAny) {
      newFacet = {
        facetId: facetType.id,
        operatorId: Number(selectedOperator),
        value1: newValue.toString(),
        value2: '',
      };
      const specificInstallFacets = facets.filter((facet) => facet.value1 !== '');
      setFacets([...specificInstallFacets, newFacet]);
    }
  };

  const handleSelectValueOnChange = (values, action) => {
    if (action.action === 'select-option') {
      handleAddFacetValue(
        values.length > 0
          ? values[values.length - 1].value
          : '',
      );
    }
    /* istanbul ignore next */
    if (action.action === 'remove-value') {
      if (!isAny) {
        const facetToRemoveIndex = facets
          .findIndex((facet) => facet.value1 === action.removedValue.value);
        removeFacet(facetToRemoveIndex);
      }
    }

    if (action.action === 'clear') {
      clearFacets();
    }
  };

  const handleToggleIsAny = (e) => {
    const { value } = e.target;
    if (value === 'true') {
      // remove specific installation link facets when switching to ANY radio button
      setFacets(facets.filter((facet) => facet.value1 === ''));
    } else {
      setIsAny(false);
    }
  };

  React.useEffect(() => {
    if (facets.length > 0) {
      const firstFacet = facets[0];
      setSelectedOperator(firstFacet.operatorId);
    } else {
      addFacet({
        facetId: facetType.id,
        operatorId: Number(selectedOperator),
        value1: '',
        value2: '',
      });
    }
  }, [facets, setFacets]);

  /* istanbul ignore next */
  return (
    <div>
      <h6>
        {facetClass.getDescription()}
      </h6>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <select
              className="form-control"
              data-testid="operator-combobox"
              onChange={handleSelectOperatorOnChange}
              value={selectedOperator}
            >
              {
                  facetClass.getOperatorSelectOptions().map((option) => (
                    <option key={option.label} value={option.value}>
                      {option.label}
                    </option>
                  ))
                }
            </select>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="isAny"
              id="isAny"
              value="true"
              onChange={(e) => handleToggleIsAny(e)}
              checked={isAny}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="form-check-label" htmlFor="isAny">
              to any installation of Link
            </label>
          </div>
        </div>
      </div>
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="isSpecific"
              id="isSpecific"
              value="false"
              onChange={(e) => handleToggleIsAny(e)}
              checked={!isAny}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="form-check-label" htmlFor="isSpecific">
              to the following installation(s) of Link:
            </label>
          </div>
        </div>
      </div>
      {
        !isAny && (
        <div className="row my-3">
          <div className="offset-sm-2 col-sm-8">
            <div className="form-group">
              <form data-testid="form">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="sr-only" htmlFor="facetValue">Facet Value</label>
                <Select
                  name="facetValue"
                  inputId="facetValue"
                  isMulti
                  isClearable={false}
                  onChange={handleSelectValueOnChange}
                  options={valueSelectOptions}
                  value={AdvancedSearchUtility.getSelectedOptionsByValue(
                    valueSelectOptions,
                    facets,
                    'value1',
                  )}
                />
              </form>
            </div>
          </div>
        </div>
        )
      }
    </div>

  );
}
FilterModalPatternF.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number,
    validOperators: PropTypes.arrayOf(PropTypes.number),
    displayValue: PropTypes.string,
    modalType: PropTypes.number,
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape(searchFilterPropType)).isRequired,
  setFacets: PropTypes.func.isRequired,
  addFacet: PropTypes.func.isRequired,
  removeFacet: PropTypes.func.isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
  clearFacets: PropTypes.func.isRequired,
};
export default FilterModalPatternF;
